// src/services/licenciesServices.js
import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/api/licencies`;

/* =========================
   Helpers
   ========================= */
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const normLicence = (v = "") => String(v).trim().toUpperCase();

const buildQuery = (params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    usp.append(k, String(v));
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

/* =========================
   GET
   ========================= */
// Tous les licenciés
export const getLicencies = async () => {
  try {
    const { data } = await axios.get(`${baseUrl}/getAll`, {
      headers: { ...authHeaders() },
    });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("Erreur getLicencies:", e);
    return [];
  }
};

// Par ID
export const getLicencieById = async (id) => {
  try {
    const { data } = await axios.get(`${baseUrl}/getById/${id}`, {
      headers: { ...authHeaders() },
    });
    return data || null;
  } catch (e) {
    console.error("Erreur getLicencieById:", e);
    return null;
  }
};

// Par numéro de licence (dernier enregistrement/saison la plus récente renvoyé par le back)
export const getLicencieByLicenceNumber = async (licence_number) => {
  try {
    const ln = normLicence(licence_number);
    const { data } = await axios.get(
      `${baseUrl}/byLicence/${encodeURIComponent(ln)}`,
      { headers: { ...authHeaders() } }
    );
    return data || null;
  } catch (e) {
    console.error("Erreur getLicencieByLicenceNumber:", e);
    return null;
  }
};

/* =========================
   CHECK (scan code-barres)
   ========================= */
// /api/licencies/check?licence_number=XXX&saison=2025-2026 (saison optionnelle)
export const checkLicencie = async ({ licence_number, saison } = {}) => {
  try {
    const ln = normLicence(licence_number);
    const qs = buildQuery({ licence_number: ln, saison });
    const { data } = await axios.get(`${baseUrl}/check${qs}`, {
      headers: { ...authHeaders() },
    });
    // data: { found, saison_ok, saison_scanned?, saison_detected?, licencie, message }
    return data;
  } catch (e) {
    console.error("Erreur checkLicencie:", e);
    return {
      found: false,
      saison_ok: false,
      licencie: null,
      message: "Erreur lors de la vérification.",
    };
  }
};

/* =========================
   POST / PUT / DELETE
   ========================= */
export const addLicencie = async (payload) => {
  try {
    const body = {
      ...payload,
      licence_number: normLicence(payload?.licence_number),
    };
    const { data } = await axios.post(`${baseUrl}/add`, body, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
    });
    return data || null;
  } catch (e) {
    console.error("Erreur addLicencie:", e);
    return null;
  }
};

export const updateLicencie = async (id, payload) => {
  try {
    const body = { ...payload };
    if (typeof body.licence_number !== "undefined") {
      body.licence_number = normLicence(body.licence_number);
    }
    const { data } = await axios.put(`${baseUrl}/update/${id}`, body, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
    });
    return data || null;
  } catch (e) {
    console.error("Erreur updateLicencie:", e);
    return null;
  }
};

export const deleteLicencie = async (id) => {
  try {
    const { data } = await axios.delete(`${baseUrl}/delete/${id}`, {
      headers: { ...authHeaders() },
    });
    return data || null;
  } catch (e) {
    console.error("Erreur deleteLicencie:", e);
    return null;
  }
};
